import { WaterbodyDetail } from '@omniafishing/core';
import { useQueryString } from '../../../hooks/use_query_string';
import { WaterbodyDetailQueryParams } from '../waterbody_detail';
import { useWaterbodyState } from './use_waterbody_state';

export interface WebAnalyticsLakeClickArgs {
  season: string;
  species: string;
  technique: string;
  waterbody_slug: string;
}

export const useWaterbodyWebAnalyticsArgs = (waterbody: WaterbodyDetail) => {
  const { getCurrentQuery } = useQueryString();

  const { selectedSeasonGroup, selectedSpecies } = useWaterbodyState({
    waterbody,
  });

  const currentQuery = getCurrentQuery<WaterbodyDetailQueryParams>();

  const webAnalyticsLakeClickArgs = {
    season: currentQuery.season_group || selectedSeasonGroup.name,
    species: currentQuery.species || selectedSpecies.name,
    technique: currentQuery.technique,
    waterbody_slug: waterbody.url_slug,
  };

  return webAnalyticsLakeClickArgs;
};
